<!-- @if (authService.isLoggedIn) { -->
<div class="row" id="body-row">
  <!-- Sidebar -->
  @if (authService.isLoggedIn) {
  <div
    id="sidebar-container"
    [ngClass]="sidebarClass"
    class="d-none d-sm-block"
    role="navigation"
    aria-label="Primary navigation"
  >
    <!-- d-* hiddens the Sidebar in smaller devices. Its itens can be kept on the Navbar 'Menu' -->
    <!-- Bootstrap List Group -->
    <a title="Document Search" [attr.aria-label]="'Document Search'" routerLinkActive="active" class="search" [routerLink]="['/documents']" [queryParams]="{from: 'sidebar'}">
      <span></span>
      <div [ngClass]="sidebarText">
        Document Search
      </div>
    </a>
    @if(authService.isAdmin()) {
      <a title="Admin" [attr.aria-label]="'Admin'" routerLinkActive="active" class="sos-staff" [routerLink]="['/admin/users']">
        <span></span>
        <div [ngClass]="sidebarText">
          Admin
        </div>
      </a>
    }
    <div (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" (keydown.space)="toggleSidebar()" [ngClass]="arrowClass" id="sidebar-toggle" class="toggle">
      <img [addAaTags]="'Sidebar Collapse'" [src]="imgSrc">
    </div>
  </div>
  }
  <!-- sidebar-container END -->
  <!-- MAIN -->
  <main
    id="main"
    tabindex="-1"
    class="main-container"
    [ngClass]="authService.isLoggedIn ? rightSidebarClass: 'col-sm-12 nopadding'"
  >
    <ng-content></ng-content>
  </main><!-- Main Col END -->
</div>
<!-- } @else {
<ng-content></ng-content>
} -->
